import { HttpStatusCode } from "axios";
import networkService from "./NetworkService";
import IVacancy from "../models/recruitment/IVacancy";
import IApplication from "../models/recruitment/IApplication";

class RecruitmentService {
    /**
     * @description Gets all vacancies
     */
    async getVacancies(): Promise<IVacancy[]> {
        const result = await networkService.get<IVacancy[]>(`/vacancies`);

        if (!result.isSuccessful) {
            throw result.data;
        }

        return result.status === HttpStatusCode.NoContent
            ? []
            : result.data as IVacancy[];
    }

    /**
     * @description Submits a recruitment application
     * @param {IApplication} application The application data (fields, including files)
     */
    async submitApplication(application: IApplication, cv: File, coverLetter: File): Promise<string> {
        const formData = new FormData();
        formData.append("applicationJson", JSON.stringify(application));
        formData.append("cv", cv);
        formData.append("coverLetter", coverLetter);

        const result = await networkService.put<FormData, any>(`/recruitment/apply`, formData);

        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }
}

const recruitmentService = new RecruitmentService();
export default recruitmentService;